const priceFormatter = (price?: string | number) => {
  if (price === undefined) {
    return;
  }
  return (price + '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export default priceFormatter;
